import React, { useState } from "react";
import "./donate.css";
import donatepage from "../../Images/banner.png";
import dummyQR from "../../Images/Qrcode.jpg";

function DonationPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    amount: "",
    message: "",
    address: "",
    purpose: "",
  });

  const [paymentMode, setPaymentMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePaymentChange = (e) => {
    setPaymentMode(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetch(
        "https://api.deepticentre.com/deeptischool/add/donation",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSuccessMsg("Donation submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "", // Reset phone field
          amount: "",
          message: "",
          address: "",
          purpose: "",
        });
        setPaymentMode("");
      } else {
        throw new Error("Submission failed");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMsg("Failed to submit donation.");
    } finally {
      setLoading(false);
    }
  };
  //--------------------
  const regexPatterns = {
    name: /^[A-Za-z\s]{3,}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^[0-9]{10}$/,
    amount: /^[1-9][0-9]*$/,
  };

  //--------------------

  return (
    <>
      <div className="donation-container">
        <img className="donate-now-page" src={donatepage} alt="Donate Banner" />
      </div>

      <div className="why-donate-section">
        <div className="two-column-layout">
          <div className="left-column">
            <h2>Why Donate to Deepti?</h2>
            <ul className="benefits-list">
              <li>
                <span className="checkmark">✓</span> Educate and empower 220+
                children with special needs
              </li>
              <li>
                <span className="checkmark">✓</span> Support therapy sessions
              </li>
              <li>
                <span className="checkmark">✓</span> Provide meals, transport,
                and equipment
              </li>
              <li>
                <span className="checkmark">✓</span> Help families integrate
                with dignity
              </li>
            </ul>

            <div className="contact-information left-align">
              <h3>Contact Us</h3>
              <div className="contact-details">
                <p>
                  <strong>Address:</strong>
                </p>
                <p>The Managing Trustee</p>
                <p>Deepti Educational and Charitable Foundation</p>
                <p>E. V. Road, Chennampallil, Adoor. 691523</p>
                <p>
                  <strong>Phone:</strong> 9633470888, 9567963030
                </p>
                <p>
                  <strong>Email:</strong> deepticharity@gmail.com
                </p>
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="donation-form-container">
              <h3>Donation Form</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    pattern="[A-Za-z\s]+"
                    title="Only alphabets are allowed"
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(
                        /[^A-Za-z\s]/g,
                        ""
                      ))
                    } // Ensures only alphabets and spaces
                  />
                </div>

                <div className="form-group">
                  <label>Address</label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => {
                      const { value } = e.target;
                      setFormData((prev) => ({
                        ...prev,
                        email: value,
                      }));

                      // Inline email validation regex
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      setFormErrors((prev) => ({
                        ...prev,
                        email: emailRegex.test(value)
                          ? ""
                          : "Please enter a valid email address.",
                      }));
                    }}
                    required
                  />
                  {formErrors.email && (
                    <small className="error-text" style={{ color: "red" }}>
                      {formErrors.email}
                    </small>
                  )}
                </div>

                {/* Phone Number Field */}
                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    pattern="[0-9]{10}"
                    title="Enter a 10-digit phone number"
                    inputMode="numeric"
                    maxLength="10"
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    } // Ensures only numbers are entered
                  />
                </div>

                <div className="form-group">
                  <label>Donation Amount</label>
                  <input
                    type="text"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                    required
                    pattern="^\d+(\.\d{1,2})?$"
                    title="Enter a valid donation amount (e.g., 10, 10.50)"
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
                    } // Ensures only numbers and a single decimal point are entered
                  />
                </div>

                <div className="form-group">
                  <label>Message (Optional)</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="form-group">
                  <label>Purpose of Donation</label>
                  <select
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Purpose --</option>
                    <option value="Building">For Building</option>
                    <option value="Students">For Students</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Payment Mode</label>
                  <div className="radio-options">
                    <div className="radio-option">
                      <input
                        type="radio"
                        id="upi"
                        name="paymentMode"
                        value="UPI"
                        checked={paymentMode === "UPI"}
                        onChange={handlePaymentChange}
                      />
                      <label htmlFor="upi">UPI</label>
                    </div>
                    <div className="radio-option">
                      <input
                        type="radio"
                        id="bank"
                        name="paymentMode"
                        value="Bank Transfer"
                        checked={paymentMode === "Bank Transfer"}
                        onChange={handlePaymentChange}
                      />
                      <label htmlFor="bank">Bank Transfer</label>
                    </div>
                  </div>
                </div>

                {paymentMode === "UPI" && (
                  <div className="qr-code-section">
                    <p>Scan the QR code below to complete your UPI payment:</p>
                    <img
                      src={dummyQR}
                      alt="UPI QR Code"
                      className="qr-code-image"
                    />
                  </div>
                )}

                {paymentMode === "Bank Transfer" && (
                  <div className="bank-details-section">
                    <div className="bank-details-box">
                      <h4>Support Deepti: Donations from India</h4>
                      <p>
                        You can support Deepti through donation and sponsorship
                        by transferring money (in Rupees only).
                      </p>
                      <p>
                        <strong>Acc. Name:</strong> Deepti Educational and
                        Charitable Foundation
                      </p>
                      <p>
                        <strong>Acc. No.</strong> 16950100021359
                      </p>
                      <p>
                        <strong>IFSC:</strong> FDRL0001695
                      </p>
                      <p>
                        <strong>FEDERAL BANK, MANAKALA</strong>
                      </p>
                      <p>(All donations are tax-exempted)</p>
                    </div>
                  </div>
                )}

                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Donate Securely"}
                </button>

                {successMsg && <p className="success-message">{successMsg}</p>}
                {errorMsg && <p className="error-message">{errorMsg}</p>}

                <div className="secure-payment">
                  <span className="secure-icon"></span>
                  100% Secure Payments
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DonationPage;
